import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

interface CustomToastProps {
  message: string;
  color: string;
  bgColor: string;
  open: boolean;
  onClose: () => void;
  icon?: React.ReactNode;
  duration?: number;
  anchorOrigin?: {
    vertical: "top" | "bottom";
    horizontal: "left" | "center" | "right";
  };
}

const CustomToast: React.FC<CustomToastProps> = ({
  message,
  color,
  bgColor,
  open,
  onClose,
  icon,
  duration = 3500,
  anchorOrigin = { vertical: "top", horizontal: "center" },
}) => {
  const handleClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") return;
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        severity="info"
        onClose={handleClose}
        icon={icon ?? false}
        action={
          <IconButton size="small" onClick={onClose} sx={{ color: icon ? color : "#fff" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{
          backgroundColor: bgColor,
          color: color ?? "#fff",
          alignItems: "center",
          borderRadius: "20px",
          boxShadow:
            "0px 2px 4px 0px rgba(0, 0, 0, 0.16), 0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
          "& .MuiAlert-action": { paddingTop: 0 },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomToast;
